"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _logoModule = _interopRequireDefault(require("./logo.module.css"));

class Logo extends _react.default.Component {
  static renderText(darkText, className) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(_logoModule.default.text, className)
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 630 59",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/_react.default.createElement("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: `logo-text-${className}`,
      fill: darkText ? '#1D354F' : '#FFFFFF',
      fillRule: "nonzero"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M44.1986967,0.20512 L28.9058967,0.20512 C21.2436709,-0.0682079848 13.786037,2.70976064 8.16989672,7.92928 C2.75286892,13.2561762 -0.159518926,20.6250196 0.151976724,28.216 C-0.0692402839,36.0051839 2.88034003,43.5506219 8.32541672,49.1248 C13.7774301,54.6635093 21.2932553,57.6761025 29.0614167,57.43648 L44.3542167,57.43648 C52.1238792,57.6845964 59.6429845,54.6706884 65.0902167,49.1248 C70.4402111,43.5066384 73.2995301,35.9690001 73.0217367,28.216 C73.3086564,20.6157035 70.3715616,13.2478634 64.9346967,7.92928 C59.3216041,2.70482177 51.8618488,-0.0739371012 44.1986967,0.20512 Z M44.1986967,45.4096 L28.9058967,45.4096 C24.4247359,45.5958487 20.0597812,43.9558728 16.8098967,40.86496 C13.625374,37.7711669 11.9149998,33.4637906 12.1097367,29.02816 C11.9168661,24.5217613 13.622618,20.1410057 16.8120402,16.9515835 C20.0014624,13.7621612 24.3822181,12.0564094 28.8886167,12.24928 L44.1814167,12.24928 C48.6866789,12.0753535 53.0637354,13.7698997 56.2774167,16.93216 C59.4756504,20.1248221 61.1871195,24.5132043 60.9948567,29.02816 C61.1895937,33.4637906 59.4792195,37.7711669 56.2946967,40.86496 C53.0514139,43.9754452 48.6899913,45.645247 44.1986967,45.496 L44.1986967,45.4096 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M147.965097,9.43264 C144.007977,3.26368 137.044137,0.136 127.229097,0.136 L86.7766167,0.136 L86.7766167,57.35008 L127.298217,57.35008 C137.562537,57.35008 144.578217,54.03232 148.414377,47.50048 C151.897687,41.4032941 150.596166,33.6953943 145.303977,29.08 C148.576722,26.1829093 150.435663,22.0113186 150.401577,17.64064 C150.373386,14.7305643 149.529232,11.8867825 147.965097,9.43264 Z M128.732457,23.13568 L106.907817,23.13568 L106.907817,35.23168 L128.732457,35.23168 C130.948174,35.199977 133.148946,35.5990504 135.212457,36.40672 C138.668457,37.85824 138.668457,39.75904 138.668457,40.3984 C138.668457,41.03776 138.668457,42.85216 135.298857,44.26912 C133.217284,45.0498336 131.007126,45.4308955 128.784297,45.39232 L98.8207767,45.39232 L98.8207767,12.16288 L128.732457,12.16288 C131.000603,12.1182868 133.253585,12.5418238 135.350697,13.40704 C137.545257,14.42656 138.616617,15.79168 138.616617,17.57152 C138.616617,18.72928 138.288297,20.44 135.350697,21.80512 C133.267122,22.7230576 131.008897,23.1770611 128.732457,23.13568 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M220.973097,25.76224 C217.054058,22.4682407 212.058866,20.7334575 206.941737,20.88928 L181.142697,20.88928 C179.744914,20.9345537 178.371545,20.5152507 177.237417,19.69696 C176.269623,18.9726954 175.73071,17.81046 175.803177,16.60384 C175.747387,15.3916855 176.289838,14.2292919 177.254697,13.49344 C178.36529,12.6367446 179.74107,12.1964952 181.142697,12.24928 L223.651497,12.24928 L223.651497,0.15328 L181.142697,0.15328 C176.533073,0.0120967956 172.022022,1.50557889 168.407337,4.3696 C164.760153,7.3088711 162.69554,11.7832637 162.825897,16.4656 C162.676337,21.1763096 164.742058,25.6850813 168.407337,28.648 C172.022022,31.5120211 176.533073,33.0055032 181.142697,32.86432 L206.941737,32.86432 C209.068611,32.7995342 211.172495,33.3195281 213.024297,34.36768 C214.754149,35.2484284 215.828152,37.040672 215.789097,38.98144 C215.824283,40.947558 214.79295,42.7788359 213.093417,43.768 C211.231592,44.8620934 209.100533,45.4128165 206.941737,45.35776 L163.949097,45.35776 L163.949097,57.45376 L206.941737,57.45376 C212.033037,57.6134529 217.012373,55.9393658 220.973097,52.73632 C224.912357,49.4030596 227.108849,44.4498116 226.934697,39.29248 C227.09719,34.1126657 224.905245,29.1379019 220.973097,25.76224 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M367.144617,34.07392 C370.230618,30.544888 371.888241,25.9910445 371.792937,21.304 C371.792937,14.15008 369.114537,8.65504 363.809577,4.95712 C359.282217,1.76032 353.303337,0.136 346.028457,0.136 L305.524137,0.136 L305.524137,57.43648 L317.620137,57.43648 L317.620137,12.24928 L347.479977,12.24928 C358.003497,12.24928 359.213097,17.43328 359.213097,21.2176 C359.337038,23.9037359 358.019946,26.4523075 355.757097,27.90496 C353.251839,29.3671824 350.377768,30.0751998 347.479977,29.944 L325.655337,29.944 L325.655337,42.04 L341.984937,42.04 L357.277737,57.43648 L374.851497,57.43648 L357.571497,40.32928 C361.261443,39.1313442 364.565739,36.9722193 367.144617,34.07392 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M416.012457,39.67264 L392.407977,0.20512 L377.184297,0.20512 L408.875817,52.408 C411.381417,56.4688 413.575977,58.3696 415.787817,58.3696 C417.999657,58.3696 420.332457,56.41696 422.786217,52.408 L455.220777,0.25696 L439.997097,0.25696 L416.012457,39.67264 Z"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "463.497897",
      y: "0.20512",
      width: "12.02688",
      height: "57.21408"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M529.110057,2.08864 C525.757737,-0.53792 522.733737,-0.77984 518.897577,2.17504 C517.51323,3.23046465 516.340679,4.53785878 515.441577,6.02848 L484.631337,57.43648 L499.768617,57.43648 L523.735977,17.95168 L531.511977,30.85984 L516.512937,42.04 L538.303017,42.04 L547.444137,57.35008 L562.650537,57.45376 L532.548777,6.04576 C531.663357,4.52094044 530.496449,3.17811673 529.110057,2.08864 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M617.047977,0.20512 L617.047977,36.49312 L584.025897,3.38464 C582.423747,1.5174256 580.138841,0.371859369 577.684137,0.20512 C576.130818,0.158988409 574.653083,0.875270187 573.727017,2.1232 C572.856652,3.29562849 572.400746,4.72413468 572.431017,6.184 L572.431017,57.43648 L584.388777,57.43648 L584.388777,21.304 L617.341737,54.44704 C619.795497,56.86624 622.024617,58.05856 624.150057,58.05856 C625.964457,58.05856 629.023017,57.21184 629.023017,51.52672 L629.023017,0.20512 L617.047977,0.20512 Z"
    }), /*#__PURE__*/_react.default.createElement("rect", {
      x: "240.706857",
      y: "0.20512",
      width: "49.7664",
      height: "12.02688"
    }), /*#__PURE__*/_react.default.createElement("polygon", {
      points: "252.733737 34.4368 287.984937 34.4368 287.984937 22.40992 240.706857 22.40992 240.706857 57.43648 290.473257 57.43648 290.473257 45.4096 252.733737 45.4096"
    })))));
  }

  render() {
    const {
      onlyText,
      showText,
      darkText,
      colorLogo,
      darkLogo,
      stacked,
      className,
      classNames
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": this.props['data-testid'] // eslint-disable-line
      ,
      className: (0, _clsx.default)(_logoModule.default.container, className, stacked && _logoModule.default.stacked)
    }, !onlyText ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(_logoModule.default.logo, classNames.logo)
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: (0, _clsx.default)(classNames && classNames.logo),
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      viewBox: "0 0 155 170"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: `logo-bottom-${className}`,
      x1: "14.374%",
      x2: "87.895%",
      y1: "75.278%",
      y2: "16.33%"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: "#16A6B7"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: "#0CCBB2"
    })), /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: `logo-top-${className}`,
      x1: "15.162%",
      x2: "87.895%",
      y1: "79.888%",
      y2: "16.33%"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: "#0FBDB4"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: "#0AD2B1"
    })), /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: `logo-inner-${className}`,
      x1: "12.453%",
      x2: "87.895%",
      y1: "84.924%",
      y2: "16.33%"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: "#199DB8"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: "#09D7B0"
    })), /*#__PURE__*/_react.default.createElement("linearGradient", {
      id: `logo-outer-${className}`,
      x1: "12.453%",
      x2: "87.895%",
      y1: "84.924%",
      y2: "16.33%"
    }, /*#__PURE__*/_react.default.createElement("stop", {
      offset: "0%",
      stopColor: "#1D8DBA"
    }), /*#__PURE__*/_react.default.createElement("stop", {
      offset: "100%",
      stopColor: "#03ECAE"
    }))), /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(5 4)"
    }, /*#__PURE__*/_react.default.createElement("path", {
      className: classNames.outer,
      stroke: colorLogo ? `url(#logo-outer-${className})` : darkLogo ? '#1D354F' : '#FFFFFF',
      strokeLinecap: "round",
      strokeWidth: "9",
      d: "M0.169921875,45.3710937 L0.169921875,108.608927 C0.169921875,117.537579 4.93173474,125.788467 12.6626808,130.25538 L60.2024227,157.723668 C67.9292511,162.188201 77.449966,162.195513 85.1836425,157.742853 L132.763208,130.348945 C140.605662,125.833656 145.395785,117.43275 145.287437,108.383983 L144.632561,53.6916034 C144.527314,44.9018236 139.813454,36.8131748 132.217739,32.3886498 L77.4433594,0.482421875"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: classNames.inner,
      stroke: colorLogo ? `url(#logo-inner-${className})` : darkLogo ? '#1D354F' : '#FFFFFF',
      strokeLinecap: "round",
      strokeWidth: "9",
      d: "M67.9472656,139.939453 L27.8831447,117.370944 C23.2387346,114.754703 20.3317127,109.87015 20.2469952,104.540226 L19.5255594,59.1517695 C19.4381873,53.654834 22.3649127,48.5505283 27.1530689,45.8491411 L64.9675554,24.514923 C69.5321799,21.9396482 75.1099232,21.9335508 79.6801672,24.4988397 L117.843157,45.9198175 C122.586425,48.5822253 125.516691,53.6038185 125.501079,59.0431902 L125.370117,104.672852"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: classNames.top,
      fill: colorLogo ? `url(#logo-top-${className})` : darkLogo ? '#1D354F' : '#FFFFFF',
      fillRule: "nonzero",
      d: "M44.204,54.2147045 L68.9,39.9767045 C71.1276878,38.6905484 73.8723122,38.6905484 76.1,39.9767045 L100.76,54.2147045 C101.417754,54.5747311 101.826757,55.2648646 101.826757,56.0147045 C101.826757,56.7645444 101.417754,57.4546779 100.76,57.8147045 L74.3,73.0787045 C73.2215992,73.7100124 71.8864008,73.7100124 70.808,73.0787045 L44.204,57.7607045 C43.5730803,57.393098 43.1850416,56.717906 43.1850416,55.9877045 C43.1850416,55.257503 43.5730803,54.582311 44.204,54.2147045 Z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: classNames.bottom,
      fill: colorLogo ? `url(#logo-bottom-${className})` : darkLogo ? '#1D354F' : '#FFFFFF',
      fillRule: "nonzero",
      d: "M109.76,68.8667045 L109.76,98.3147045 C109.763797,100.890809 108.390976,103.272654 106.16,104.560705 L76.1,121.930705 C73.8723122,123.216861 71.1276878,123.216861 68.9,121.930705 L38.84,104.560705 C36.609024,103.272654 35.2362029,100.890809 35.24,98.3147045 L35.24,68.8667045 C35.2317401,68.1295068 35.6195858,67.444538 36.2559963,67.0723681 C36.8924068,66.7001983 37.6795547,66.6980362 38.318,67.0667045 L69.782,85.2467045 C70.6086024,85.7266107 71.5443165,85.9868755 72.5,86.0027045 C73.4614363,86.0046553 74.4059602,85.7498824 75.236,85.2647045 L106.7,67.0847045 C107.334505,66.7268648 108.111161,66.7322392 108.740653,67.0988257 C109.370145,67.4654122 109.7581,68.1382527 109.76,68.8667045 Z"
    })))) : null, showText ? Logo.renderText(darkText, classNames.text) : onlyText ? Logo.renderText(darkText, classNames.text) : null);
  }

}

Logo.defaultProps = {
  onlyText: false,
  showText: false,
  darkText: false,
  colorLogo: false,
  darkLogo: false,
  stacked: false,
  className: 'container',
  classNames: {
    logo: 'logo',
    text: 'text',
    outer: 'outer',
    inner: 'inner',
    top: 'top',
    bottom: 'bottom'
  }
};
Logo.propTypes = {
  onlyText: _propTypes.default.bool,
  showText: _propTypes.default.bool,
  darkText: _propTypes.default.bool,
  colorLogo: _propTypes.default.bool,
  darkLogo: _propTypes.default.bool,
  stacked: _propTypes.default.bool,
  className: _propTypes.default.string,
  classNames: _propTypes.default.shape({
    logo: _propTypes.default.string,
    text: _propTypes.default.string,
    bottom: _propTypes.default.string,
    top: _propTypes.default.string,
    outer: _propTypes.default.string,
    inner: _propTypes.default.string
  })
};
var _default = Logo;
exports.default = _default;